export default __webpack_public_path__ + "static/media/filter.19a959e3.svg";